import { useState } from 'react';
import classNames from 'classnames';
import { getEnv } from '../../../../../../../environment';
import HamburgerMenuIcon from '../../../../../HamburgerMenuIcon';
import { getLogoImage } from '../../../../../../utils/getLogoImage';
import MobileMenu from '../../../MobileMenu/MobileMenu';
import * as styles from './LeftMenu.module.scss';

type Props = {
  isLoginPage?: boolean;
  isPublicShop?: boolean;
};

export const LeftMenu = ({ isLoginPage, isPublicShop }: Props) => {
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const toggleMenu = () => setIsOpenMenu(!isOpenMenu);

  const env = getEnv();

  return (
    <div className={styles.leftMenuContainer} data-testid="left-menu">
      <div className={styles.headerMenuContainer}>
        <HamburgerMenuIcon isOpen={isOpenMenu} onClick={toggleMenu} />
        <div className={styles.logoContainer}>
          <a className={styles.fffLogo} href={env.REACT_APP_BASE_URL} data-testid="logo-link">
            <img src={getLogoImage(env?.name)} alt="fabfitfun logo" />
          </a>
        </div>
        <div className={classNames(styles.rightContainer, { [styles.hidden]: isPublicShop })}></div>
      </div>
      <div className={styles.mobileMenuContainer}>
        <MobileMenu isOpenMenu={isOpenMenu} isLoginPage={isLoginPage} isPublicShop={isPublicShop} />
      </div>
    </div>
  );
};
